import { useMutation, useQueryClient } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  contractParkingSpotsKey,
  type IncludeFilter,
} from './useAPIGetContractParkingSpots'
import {
  parkingSpotResponseSchema,
  TerminateReservationBody,
} from '../../../common/validations/parkingSpotSchemas'

import { post } from 'api/apiClient'

export const useAPITerminateContractParkingSpotReservation = (
  contractUuid?: string
) => {
  const qc = useQueryClient()
  return useMutation({
    mutationKey: contractUuid
      ? ([
          'contracts',
          contractUuid,
          'parking-spots',
          'terminate-reservation',
        ] as const)
      : undefined,
    mutationFn: async (body: TerminateReservationBody) => {
      if (!contractUuid) throw new Error('Missing contractUuid for termination')
      const url =
        API_ENDPOINTS.CONTRACT_PARKING_SPOT_RESERVATIONS_TERMINATE?.replace(
          ':contractUuid',
          contractUuid
        ) ?? `/contracts/${contractUuid}/parking-spots/reservations/terminate`
      return post(url, body, parkingSpotResponseSchema)
    },
    retry: false,
    onSuccess: async (_data, _vars, _ctx) => {
      const invalidate = (inc: IncludeFilter) =>
        qc.invalidateQueries({
          queryKey: contractParkingSpotsKey(contractUuid!, inc),
        })
      await Promise.all([invalidate('all'), invalidate('own')])
    },
  })
}
